import React from 'react';

const ConsumerRights = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-black to-gray-900 text-white py-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-white mb-4">זכויות הצרכן</h1>
          <p className="text-gray-300 text-lg">מידע חשוב לרוכשי רכבים ב-J CLASS MOTORS</p>
        </div>

        <div className="bg-black/50 backdrop-blur-sm border border-amber-500/20 rounded-2xl p-8 space-y-8">
          <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-4 mb-8">
            <p className="text-amber-300 text-sm">
              <strong>הערה חשובה:</strong> המידע הבא הינו לצרכי מידע בלבד ואינו מהווה ייעוץ משפטי. 
              יש להתייעץ עם עורך דין מוסמך לגבי זכויותיך הספציפיות.
            </p>
          </div>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              1. חוק הגנת הצרכן התשמ"א-1981
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>
                כצרכן, זכאי אתה להגנה מלאה בהתאם לחוק הגנת הצרכן הישראלי.
              </p>
              <p>החוק מעניק לך זכויות חשובות ביניהן:</p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li>זכות לקבלת מידע מלא וברור על המוצר</li>
                <li>זכות לביטול עסקה בתנאים מסוימים</li>
                <li>זכות לאחריות על המוצר</li>
                <li>זכות לטיפול הוגן ולא מפלה</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              2. ביטול עסקה
            </h2>
            <div className="text-gray-300 space-y-3">
              <p><strong>ביטול עסקה מחוץ לעסק (הזמנה טלפונית/דיגיטלית):</strong></p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li>זכות ביטול עד 14 ימים מיום קבלת המוצר</li>
                <li>אין צורך לנמק את הביטול</li>
                <li>החזרת כספים תתבצע תוך 14 ימי עבודה</li>
              </ul>
              
              <p className="mt-4"><strong>ביטול עסקה בעסק:</strong></p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li>לרכבים חדשים - זכות ביטול עד 7 ימים או 1,000 ק"מ</li>
                <li>לרכבים משומשים - בהתאם לתנאי ההסכם</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              3. אחריות על רכבים
            </h2>
            <div className="text-gray-300 space-y-3">
              <p><strong>רכבים חדשים:</strong></p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li>אחריות היצרן - בדרך כלל 3-5 שנים או עד מספר קילומטרים מסוים</li>
                <li>אחריות על פגמים נסתרים - עד 6 חודשים מרכישה</li>
                <li>זכות לתיקון, החלפה או החזר כספים</li>
              </ul>
              
              <p className="mt-4"><strong>רכבים משומשים:</strong></p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li>אחריות על פגמים נסתרים - 3 חודשים לפחות</li>
                <li>אחריות נוספת ניתנת להסכמה בכתב</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              4. מידע שחובה לקבל לפני רכישה
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>לפני חתימה על הסכם רכישה, זכאי אתה לקבל:</p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li>מחיר מלא כולל כל העלויות (מע"ם, רישוי, ביטוח וכו')</li>
                <li>פרטים מלאים על הרכב (שנה, דגם, מספר קילומטרים)</li>
                <li>היסטוריית הרכב (תאונות, תיקונים)</li>
                <li>תנאי האחריות המלאים</li>
                <li>תנאי התשלום ולוח הזמנים</li>
                <li>עלויות נוספות צפויות</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              5. תלונות והליכים
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>במקרה של בעיה או מחלוקת:</p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li><strong>שלב 1:</strong> פנייה ישירה לעסק (J CLASS MOTORS)</li>
                <li><strong>שלב 2:</strong> פנייה לרשות הגנת הצרכן</li>
                <li><strong>שלב 3:</strong> תביעה בבית משפט קטן (עד 70,000 ₪)</li>
                <li><strong>שלב 4:</strong> בוררות או בית משפט אזרחי</li>
              </ul>
              
              <p className="mt-4"><strong>רשות הגנת הצרכן:</strong></p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li>טלפון: 1-800-202-303</li>
                <li>אתר: gov.il/consumers</li>
                <li>כתובת: רח' בנק ישראל 1, ירושלים</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              6. טיפים לרכישה בטוחה
            </h2>
            <div className="text-gray-300 space-y-3">
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li>בדוק תמיד את המוצר לפני החתימה</li>
                <li>קרא בעיון את כל תנאי ההסכם</li>
                <li>שמור על כל המסמכים והקבלות</li>
                <li>בדוק ביטוח מקיף לרכב</li>
                <li>וודא שהמחיר כולל את כל העלויות</li>
                <li>אל תחתום על הסכם בלחץ</li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-amber-400 mb-4 border-b border-amber-500/30 pb-2">
              7. יצירת קשר עם J CLASS MOTORS
            </h2>
            <div className="text-gray-300 space-y-3">
              <p>לטיפול בפניות צרכנים:</p>
              <ul className="list-disc list-inside space-y-2 mr-4">
                <li><strong>טלפון:</strong> 058-7019669</li>
                <li><strong>דוא"ל:</strong> support@jclassmotors.co.il</li>
                <li><strong>כתובת:</strong> תל אביב, ישראל</li>
                <li><strong>זמן טיפול:</strong> עד 14 ימי עבודה</li>
              </ul>
            </div>
          </section>

          <div className="border-t border-amber-500/30 pt-6 mt-8">
            <p className="text-gray-400 text-sm text-center">
              עדכון אחרון: {new Date().toLocaleDateString('he-IL')} | 
              J CLASS MOTORS - מכבדים את זכויות הצרכן | מידע זה בהתאם לחוק הגנת הצרכן התשמ"א-1981
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsumerRights;